import gql from "graphql-tag";

const projectStatusMutations = {


    createProjectStatus: gql`
        mutation CreateProjectStatus($name: String, $closed: Boolean, $prio: Int, $default: Boolean, $color: String, $event: String) {
            createProjectStatus(name: $name, closed: $closed, prio: $prio, default: $default, color: $color, event: $event) {
                id,
                name,
                closed,
                prio,
                default,
                color,
                event
            }
        }
    `,
    updateProjectStatus: gql`
        mutation UpdateProjectStatus($id: ID!, $name: String, $closed: Boolean, $prio: Int, $default: Boolean, $color: String, $event: String) {
            updateProjectStatus(id: $id, name: $name, closed: $closed, prio: $prio, default: $default, color: $color, event: $event) {
                id,
                name,
                closed,
                prio,
                default,
                color,
                event
            }
        }
    `,
};

export default projectStatusMutations;